import { TransactionGroupPeriodTypeCode } from 'generated/graphql';

export const PERIOD_TYPES: Record<TransactionGroupPeriodTypeCode, string> = {
  [TransactionGroupPeriodTypeCode.Week]: 'týždňov',
  [TransactionGroupPeriodTypeCode.Month]: 'mesiacov',
};

export const PERIOD_TYPE_CHOICES = Object.entries(PERIOD_TYPES)
  .map(([id, name]) => ({ id, name }))
  .sort((a, b) => a.name.localeCompare(b.name));
